import Vue from 'vue';

// When the request succeeds
const success = (response, context, rental_id) => {
    toastr.success(context.$t('rentals.detail.checklists.checklist_updated_successfully'));
    context.closeModal('#checklists-modal');

    context.newChecklistGroup = {
      title: "",
      description: "",
      checklist_group_type_id: 4,
      checklists: [],
      images: []
    },
    context.checklists = [];
    context.checklistGroupImages = [];
    context.getChecklistGroup(rental_id);

};

// When the request fails
const failed = (error, context, rental_id) => {
  context.showToasterError(error);
  context.getChecklistGroup(rental_id);
};

export default (context, checklistGroup) => {
    return Vue.$http.put('/check-list-groups/' + checklistGroup.id, checklistGroup)
        .then((response) => {
            if (response && response.status === 200) {
                success(response, context, checklistGroup.rental_id);
            }
        })
        .catch((error) => {
            failed(error, context, checklistGroup.rental_id);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/checklist_group/update.js